module.exports = __webpack_public_path__ + "img/zuopinxiaotu.d351045e.png";